import React, { Component } from 'react';
import { isEqual } from 'lodash';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { AbstractChart } from 'containers/charts/AbstractChart';
import { toolTipPointFormatterGenerator } from 'helpers/charts';

const LABEL_MIN_PERCENTAGE = 0.03;

class TreemapCallOutChart extends Component {
    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps.data, this.props.data);
    }

    render() {
        const { orderedColors } = this.props.theme;
        const { layoutAlgorithm, formatByType } = this.props;

        let valueTotal = 0;
        const seriesData = this.props.data.map((element, index) => {
            if (!element.color) {
                element.color = orderedColors[index % orderedColors.length];
            }
            valueTotal += element.value;
            return element;
        });

        const config = {
            chart: {
                margin: [0, 0, 0, 0],
                backgroundColor: 'transparent',
                height: '107px'
            },
            exporting: {
                enabled: false
            },
            title: {
                text: null
            },
            credits: {
                enabled: false
            },
            tooltip: {
                pointFormatter: toolTipPointFormatterGenerator,
                followPointer: true,
                outside: true
            },
            series: [{
                type: 'treemap',
                data: seriesData,
                formatByType,
                dataLabels: {
                    style: { textOutline: '0px contrast' },
                    formatter() {
                        if (this.point.value / valueTotal < LABEL_MIN_PERCENTAGE) {
                            return undefined;
                        }
                        return this.key;
                    }
                }
            }],
        };

        if (layoutAlgorithm) {
            config.series[0].layoutAlgorithm = layoutAlgorithm;
        }

        return (
            <AbstractChart exportName={this.props.exportName} config={config} />
        );
    }
}

TreemapCallOutChart.propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string.isRequired,
        value: PropTypes.number.isRequired,
        color: PropTypes.string
    })).isRequired,
    exportName: PropTypes.string.isRequired,
    formatByType: PropTypes.string,
    layoutAlgorithm: PropTypes.oneOf(['strip', 'stripes', 'squarified'])
};

export default withTheme(TreemapCallOutChart);



// WEBPACK FOOTER //
// ./src/components/molecules/charts/TreemapCallOutChart.js